import { ITheme, loadTheme } from "@fluentui/react";

import { defaultDarkTheme, defaultLightTheme } from "./DefaultThemes";

// Theme types supported for the users (the number of options here may grow in the future).
export enum AppTheme {
  Light,
  Dark,
}

// This class will manage the Themes offered to the users by the App.
// It allow developers to define themes that are stored in a dictionary, and
// then these can be used to load the Theme to the UI and update the UI controls.
export class AppThemeManager {
  private static instance: AppThemeManager;
  private AppThemeList: { [key in AppTheme]: ITheme } = {
    [AppTheme.Light]: defaultLightTheme,
    [AppTheme.Dark]: defaultDarkTheme,
  };
  private currentTheme: AppTheme = AppTheme.Light;

  // Singleton
  public static getInstance(): AppThemeManager {
    if (!AppThemeManager.instance) {
      AppThemeManager.instance = new AppThemeManager();
    }
    return AppThemeManager.instance;
  }

  // Get current Theme mode (as an AppTheme).
  // For example: if you just want to know if we are in dark mode or not.
  public getThemeMode(): AppTheme {
    return this.currentTheme;
  }

  // Get the current Theme (as the full ITheme).
  public getTheme(): ITheme {
    // TODO: Add check comparing with Fabric global theme and log/error handling.
    return this.AppThemeList[this.currentTheme];
  }

  // Set a new Theme definition that can be used by the App.
  // Note that this adds a theme to the dictionary, it does not load it to the UI.
  public setTheme(appTheme: AppTheme, newTheme: ITheme) {
    // Save the new Theme definition
    this.AppThemeList[appTheme] = newTheme;
  }

  // Load a given Theme to the UI (update current theme and re-render all consumer controls).
  public loadTheme(appTheme: AppTheme) {
    this.currentTheme = appTheme;
    // Load the new theme to the UI (this will update the current global Fabric theme, as well as
    // trigger re-renders in all controls set as consumers of the Theme).
    loadTheme(this.AppThemeList[appTheme]);
  }

  // Returns requested theme, for when we need to access the palette
  // for a non-active theme (e.g. header initial load)
  public getThemeForMode(theme: AppTheme) {
    return this.AppThemeList[theme];
  }
}
